export default "__VITE_PUBLIC_ASSET__faece93a__"